<script>
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import {mapGetters, mapMutations, mapState, mapActions} from 'vuex';
import {ProductApi} from '@/api/product';
import pdpBuyingZoneContainer from '@/components/containers/pdp/PdpBuyingZoneContainer';
import productTile from '@/components/containers/plp/ProductTile';
import bulkProductGridContainer from '@/components/containers/bulk-product/BulkProductGridContainer';
import techInfoContainer from '@/components/containers/tech-info/TechInfoContainer';
import GridSwitch from '@/components/grid/GridSwitch';
import ToggleSwitch from '@/components/ToggleSwitch';
import TrekLoading from '@/components/TrekLoading';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import ProductGroups from '@/components/containers/bulk-product/utils/product-groups';
import {updateStockWatchStatus} from '@/components/containers/bulk-product/utils/warehouses';

export default {
  components: {
    pdpBuyingZoneContainer,
    productTile,
    bulkProductGridContainer,
    techInfoContainer,
    ToggleSwitch,
    TrekLoading,
    GridSwitch,
    TrekButton,
    TrekLink,
  },

  props: {
    isBike: Boolean,
    baseProductCode: {
      type: String,
      required: true,
    },
    rpaModalViewStockToggle: Boolean
  },

  data() {
    return {
      productGroups: [],
      isPdp: true,
      archived: '',
    };
  },

  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode']),
    ...mapGetters('storage', ['purchaseMode']),
    ...mapGetters(['unitId']),
    ...mapState('compare', ['racks']),
    ...mapState('storage', ['purchaseMode']),
    isRackFull() {
      return this.racks[this.unitId].length === 4;
    },

    isInRack() {
      return !!find(this.racks[this.unitId], {productCode: this.productGroups.code});
    },
  },

  mounted() {
    if (this.unitId !== 'b2c') {
      this.fetchProducts();
    }
    this.setIsBike(this.isBike);
    this.setRpaViewInStockModalValue(this.rpaModalViewStockToggle);
    // We have to do this manual 'uncloacking' of the component because of the way
    // we are mixing static JSP and vue components inside this vue 'inline-template'.
    // Once we fully convert the PDP page to Vue we can use standard binding to show/hide
    // sections.
    if (this.$refs.pdpSection) {
      this.$refs.pdpSection.classList.remove('h-screen');
      this.$refs.pdpSection.classList.remove('invisible');
    }
    this.hideElementsOnPurchaseMode(this.purchaseMode);
  },

  methods: {
    ...mapActions('skuGrid', ['loadAllocatedCounts']),
    ...mapActions('pdp', ['setRpaViewInStockModalValue']),

    /**
     * Get product's ID from current URL.
     * @return {string|*}
     */
    getProductIdFromUrl() {
      const pathArray = window.location.pathname.split('/');
      const index = findIndex(pathArray, (x) => x === 'p');

      return index > -1 && pathArray.length > index + 1 ? pathArray[index + 1] : '';
    },

    /**
     * Update stock data.
     * @param payload
     */
    updateStocks(payload) {
      if (payload && payload.item) {
        updateStockWatchStatus(this.productGroups, payload.item);
      }
    },

    /**
     * Fetch product data.
     */
    fetchProducts() {
      const productId = this.getProductIdFromUrl();
      this.setBikeTechSKU(productId);

      if (this.baseProductCode) {
        ProductApi.loadProduct(this.baseProductCode).then((data) => {
          const productGroups = new ProductGroups(data);
          this.productGroups = productGroups.getProductGroups();
        });

        this.loadAllocatedCounts([this.baseProductCode]);
      }
    },

    /**
     * Switch purchase mode  (consumer friendly on / off)
     * @param e
     */
    switchPurchaseMode(e) {
      this.togglePurchaseMode(e);
      this.hideElementsOnPurchaseMode(this.purchaseMode);
    },

    hideElementsOnPurchaseMode(value) {
      let dataDrivenBikes = document.querySelector('#datadriven-bikeProduct-productOverview');
      let reviewHeader = document.querySelector('#MyReviewHeader');
      let userFaqs = document.querySelector('#questions-wrapper');
      let moreOptions = document.querySelector('#trekProductSetCarouselComponent');
      let afterMarketProductFeatures = document.querySelector('#aftermarketProductFeaturesComponent');
      let aftermarketVideoComponent = document.querySelector('.aftermarketVideoComponent');
      let displayToggle = value ? 'none' : 'block';
      if (dataDrivenBikes) {
        dataDrivenBikes.style.display = displayToggle;
      }
      if (reviewHeader) {
        reviewHeader.style.display = displayToggle;
      }
      if (userFaqs) {
        userFaqs.style.display = displayToggle;
      }
      if (moreOptions) {
        moreOptions.style.display = displayToggle;
      }
      if (afterMarketProductFeatures) {
        afterMarketProductFeatures.style.display = displayToggle;
      }
      if (aftermarketVideoComponent) {
        aftermarketVideoComponent.style.display = displayToggle;
      }
    },

    archivedValue(e) {
      this.archived = e;
    },

    ...mapActions('storage', ['togglePurchaseMode']),
    ...mapMutations('pdp', ['setIsBike']),
    ...mapMutations('pdp', ['setRpaViewInStock']),
    ...mapMutations('storage', ['setBikeTechSKU']),
  },
};
</script>
